import { SparkIcon } from '../../../components/icons';

/**
 * Empty state for "My projects" — dashed border, click opens wizard (create new).
 */
interface EmptyProjectsStateProps {
  onCreateClick: () => void;
}

export function EmptyProjectsState({ onCreateClick }: EmptyProjectsStateProps) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        padding: '48px 24px',
      }}
    >
      <div style={{ marginBottom: 20, display: 'flex', justifyContent: 'center', color: 'rgba(255,255,255,0.28)' }}>
        <SparkIcon size={40} />
      </div>
      <h3 style={{
        fontFamily: 'Unbounded, sans-serif',
        fontSize: '1rem',
        fontWeight: 700,
        color: 'rgba(255,255,255,0.9)',
        marginBottom: 8,
      }}>
        У вас пока нет проектов.
      </h3>
      <p style={{ fontSize: '0.875rem', color: 'rgba(255,255,255,0.4)', marginBottom: 28 }}>
        Создайте первый проект и покажите его миру.
      </p>
      <button
        type="button"
        className="btn btn-primary"
        onClick={(e) => { e.stopPropagation(); onCreateClick(); }}
        style={{ padding: '12px 24px', borderRadius: 12, fontSize: '0.9375rem', fontWeight: 600 }}
      >
        Создать проект
      </button>
    </div>
  );
}
